<template>
	<div class="icon-search">
		<svg
			:width="width"
			:height="height"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_2315">
					<rect
						id="search"
						width="24"
						height="24"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_2315)">
				<path
					id="path"
					d="M2.75 11C2.75 9.9 2.95 8.85 3.37 7.84C3.79 6.83 4.39 5.93 5.16 5.16C5.93 4.39 6.83 3.79 7.84 3.37C8.85 2.95 9.9 2.75 11 2.75C12.09 2.75 13.14 2.95 14.15 3.37C15.16 3.79 16.06 4.39 16.83 5.16C17.6 5.93 18.2 6.83 18.62 7.84C19.04 8.85 19.25 9.9 19.25 11C19.25 12.09 19.04 13.14 18.62 14.15C18.2 15.16 17.6 16.06 16.83 16.83C16.06 17.6 15.16 18.2 14.15 18.62C13.14 19.04 12.09 19.25 11 19.25C9.9 19.25 8.85 19.04 7.84 18.62C6.83 18.2 5.93 17.6 5.16 16.83C4.39 16.06 3.79 15.16 3.37 14.15C2.95 13.14 2.75 12.09 2.75 11L2.75 11M11 1.25C5.61 1.25 1.25 5.61 1.25 11C1.25 16.38 5.61 20.75 11 20.75C13.4 20.75 15.51 19.97 17.34 18.4L20.46 21.53C20.82 21.9 21.18 21.91 21.54 21.54C21.91 21.18 21.9 20.82 21.53 20.46L18.4 17.34C19.97 15.51 20.75 13.4 20.75 11C20.75 5.61 16.38 1.25 11 1.25L11 1.25Z"
					:fill="color"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
	props: {
		color: { type: String, default: "#FFFFFF" },
		width: { type: String, default: "24.000000" },
		height: { type: String, default: "24.000000" },
	},
})
export default class IconSearch extends Vue {}
</script>

<style scoped lang="scss">
.icon-search {
	display: flex;
}
</style>
